import { render, staticRenderFns } from "./formResponseComment.vue?vue&type=template&id=40f3b493&scoped=true&"
import script from "./formResponseComment.vue?vue&type=script&lang=js&"
export * from "./formResponseComment.vue?vue&type=script&lang=js&"
import style0 from "./formResponseComment.vue?vue&type=style&index=0&id=40f3b493&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3b493",
  null
  
)

export default component.exports